module.exports = __webpack_public_path__ + "ZAWLogoWhite.ce81a3d93c250bfbe94bfafd183657e4.svg";